











































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { loading, enumData, validateRuleData } from '@/decorators';
import { Form, FormModel } from 'ant-design-vue';
import moment, { Moment } from 'moment';
import { spawn } from 'child_process';
import { namespace } from 'vuex-class';
const User = namespace('user');

@Component({
  components: {},
})
export default class InboundPlanAddEditPage extends Vue {
  /** 更新当月备货计划状态 */
  @User.Action('setInboundPlanData') protected setInboundPlanData!: () => void;
  /** 页面类型 */
  @Prop()
  private type!: string;
  /** 表格配置参数 */
  private columns: TypeBase.TableColumn[] = [];
  /** 备货计划列表数据 */
  private formData: TypeInboundPlan.EditParams = {
    code: '',
    list: [],
  };
  /** 列表加载状态 */
  private loadingStatus: boolean = false;
  /** 校验规则 */
  private formDataRule: TypeProductCreateEdit.FormDataRule | {} = {};
  /** 发起请求时的状态 */
  private saveLoading: boolean = false;
  /** 获取校验规则 */
  private getConfirmRuleData(data: TypeCommon.CommonFormRules): void {
    const rules = {
      'list.*.deliver_volume': [
        {
          pattern: '^(([0])|([1-9]\\d{0,3})|([1-2]\\d{0,4})|(30000))$',
          message: this.t('请填写0-30000的整数'),
        },
      ],
      'list.*.remark': [],
    };
    this.formDataRule = this.$util.mergeValidate(data, rules);
  }
  /**
   * 设置columns
   */
  private setColumns(): void {
    const h = this.$createElement;
    /** 当月的计划才可以编辑、提交、删除 */
    const lastMoth = moment()
      .month(moment().month() - 1)
      .format('YYYY-MM');
    this.columns = [
      {
        title: this.t('序号'),
        dataIndex: 'index',
        width: 50,
        scopedSlots: { customRender: 'index' },
      },
      {
        title: this.t('发货年月'),
        dataIndex: 'deliver_time',
        filterEmpty: true,
        scopedSlots: { customRender: 'deliver_time' },
      },
      {
        title: this.t('区域仓'),
        dataIndex: 'warehouse_code',
        scopedSlots: { customRender: 'warehouse_code' },
      },
      {
        title: this.t('发货体积（m³）'),
        dataIndex: 'deliver_volume',
        align: 'right',
        scopedSlots: { customRender: 'deliver_volume' },
      },
      {
        title: this.t('备注'),
        dataIndex: 'remark',
        scopedSlots: { customRender: 'remark' },
      },
    ];
  }
  /**
   * 请求备货计划列表
   */
  @loading('loadingStatus')
  private async queryList(code: string): Promise<void> {
    const res = await this.$api.inboundPlan.queryStockDetails({ code });
    const item1 = this.$util.deepCopy(res.data.list[0]);
    this.formData.list = res.data.list || [];
    this.formData.code = res.data.code;
  }
  /**
   * 计算合并数据
   */
  private calRowSpan(data: any[], indexs: number[], item: any) {
    if (indexs.length) {
      data[indexs[0]].shipmentsMonthRowSpan = true;
      data[indexs[0]].shipmentsMonthRowSpanLength = indexs.length + 1;
    } else {
      item.shipmentsMonthRowSpan = true;
      item.shipmentsMonthRowSpanLength = 1;
    }
  }
  /**
   * 保存
   */
  private async handleSubmit(): Promise<void> {
    const formDataRef = this.$refs.formDataRef as FormModel;
    const validRes = await formDataRef.validate();
    if (!validRes) {
      return;
    }
    const formData = this.$util.deepCopy(this.formData);
    formData.list.forEach((item) => {
      if (String(item.deliver_volume) === '' || typeof item.deliver_volume === 'undefined') {
        item.deliver_volume = null;
      }
    });
    const hasValue = formData.list.some((item) => !!item.deliver_volume);
    if (!hasValue) {
      this.$message.warning(this.t('发货体积至少填写一项，无备货，可填写0'));
      return;
    }
    const res = await this.$api.inboundPlan.stockPlanEdit(formData);
    this.$message.success('操作成功');
    this.jumpListPage();
  }
  /**
   * 关闭页面
   */
  private jumpListPage(): void {
    if (this.type === this.$enum.common.ModalTypeEnum.ADD || this.type === this.$enum.common.ModalTypeEnum.EDIT) {
      this.$router.push({
        name: 'InboundPlanPage',
        params: {
          updateList: String(this.$enum.common.Enabled.YES),
          noCache: String(this.$enum.common.Enabled.YES),
          closeCurrent: String(this.$enum.common.Enabled.YES),
        },
      });
    }
    if (this.type === this.$enum.common.ModalTypeEnum.ADD) {
      this.setInboundPlanData();
    }
  }
  private created() {
    this.getConfirmRuleData({});
    this.setColumns();
    const code = this.$route.query.code as string;
    this.queryList(code);
  }
}
